async function initialize() {
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  // eslint-disable-next-line
  return await supabase.createClient(supabaseUrl, supabaseKey);
}

export default initialize;
